export default __webpack_public_path__ + "./img/help.d398d31552594efcad724e91f33482d4.png";